import { isEmpty, map } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { ImageObject } from '../../../../../types/__codegen__/sanity/graphql';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import type { SectionValuePropositionType } from '../../../types';

type MapValuePropositionsContentProps = {
  cmsSectionContent: SectionValuePropositionType | undefined;
};

const mapValuePropositionsContent = ({ cmsSectionContent }: MapValuePropositionsContentProps) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const mappedCmsContent = {
    cta: {
      title: cmsSectionContent?.urlObject?.name ?? null,
      to: cmsSectionContent?.urlObject?.url ?? null,
    },
    description: cmsSectionContent?.descriptionRaw,
    tiles: map(
      (valueProposition) => ({
        cta: {
          title: valueProposition?.urlObject?.name ?? null,
          to: valueProposition?.urlObject?.url ?? null,
        },
        image: getImageAttributes({ height: 352, imageObject: valueProposition?.imageObject as ImageObject }),
        summary: valueProposition?.summaryRaw,
        title: valueProposition?.sloganRaw,
      }),
      cmsSectionContent?.valuePropositions,
    ),
    title: cmsSectionContent?.title,
    type: CONTENT_SECTIONS.VALUE_PROPOSITIONS,
    withSimpleBit: false,
  };

  return mappedCmsContent;
};

export default mapValuePropositionsContent;
